import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./i18n";
import App from "@/app/App";
import { ThemeProvider } from "@/app/context/ThemeContext";
import { AppWrapper } from "@/components/common/PageMeta";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import ErrorBoundary from "@/components/error/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60, // Данные считаются свежими в течение 1 минуты
      gcTime: 1000 * 60 * 5, // Храним данные в кэше 5 минут после того, как они станут неиспользуемыми
      refetchOnMount: false, // Отключаем автоматический рефетч при монтировании
    },
  },
});

root.render(
  <React.StrictMode>
    <AppWrapper>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </AppWrapper>
  </React.StrictMode>
);
